export const SERVICE_URL = `https://${process.env.REACT_APP_BACKET}.s3.amazonaws.com/service-icons/`
